export const LAYERS_CONTAINER_NAME = '__sail-layer-containers';
export const LAYERS_CONTAINER_DEFAULT_Z = 299;

export const RESERVED_MODAL_LAYER = 'modal';
export const RESERVED_NONMODAL_LAYER = 'nonmodal';
